import {} from '@mui/material'

// material-ui

// project imports
import ViewContentHouseAccessListComponent from 'features/view/content/house/access/list/component/view-content-house-access-list-component'

// ==============================|| PROFILE 3 ||============================== //

// styles
const Profile3 = () => {
  return (
    <>
      <ViewContentHouseAccessListComponent />
    </>
  )
}

export default Profile3
